import { ALERTS } from "./alerts.reducer";

export const selectAlerts = (state) => state[ALERTS];
export const selectAlertsAsArray = (state) => Object.entries(selectAlerts(state));
